// Translations
export const T = {
  en_GB: {
    allowed: "Advisor override",
    noteRequired: "Advisor override · note",
  },
  nb_NO: {
    allowed: "Rådgiver kan overstyre",
    noteRequired: "Rådgiver kan overstyre · begrunnelse",
  },
} as const;
